/* tjs <- version.ts */

export const version = '1.6.8';